import React from 'react';

type TabButtonProps = {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
};

const TabButton: React.FC<TabButtonProps> = ({
  isActive,
  onClick,
  children,
  className,
}) => {
  return (
    <button
      className={`text-[14px] ${className} ${
        isActive ? 'text-white font-bold' : 'font-normal'
      }`}
      style={{ color: isActive ? 'white' : 'rgba(255, 255, 255, 0.6)' }}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default TabButton;
